import { render } from "./NewFeatureTourStep.vue?vue&type=template&id=52f8f3c8"
import script from "./NewFeatureTourStep.vue?vue&type=script&lang=js"
export * from "./NewFeatureTourStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/Employ/Onboarding/Modal/NewFeatureTourStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52f8f3c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52f8f3c8', __exports__)) {
    api.reload('52f8f3c8', __exports__)
  }
  
  module.hot.accept("./NewFeatureTourStep.vue?vue&type=template&id=52f8f3c8", () => {
    api.rerender('52f8f3c8', render)
  })

}


export default __exports__